import { Component, inject, OnInit } from '@angular/core';
import { Move } from '@app/move/interfaces/move';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { AppNavigationSandbox } from '@app/navigation/sandboxes/navigation.sandbox';
import { appI18nKeyTypes } from '@app/shared/constants/i18n-key-type-map';
import { DbUtils } from '@smooved/core';
import { SvgIllustration, UiContext, UiDirection } from '@smooved/ui';
import { EnergyStopStore } from '@app/services/energy-stop/store/energy-stop.store';
import { MoveUtils } from '@app/move/state/move.utils';
import { EnergyStopSuppliersStatus } from '@app/services/energy-stop/enums/energy-stop-suppliers-status';

@Component({
    selector: 'app-telecom-success',
    templateUrl: './telecom-success.container.html',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class TelecomSuccessContainer implements OnInit {
    public move: Move;
    public readonly i18nKeys = appI18nKeyTypes;
    public readonly uiDirection = UiDirection;
    public readonly uiContext = UiContext;
    public readonly illustrations = SvgIllustration;

    constructor(
        private readonly navigationSandbox: AppNavigationSandbox,
        private readonly moveSandbox: MoveSandbox
    ) {}

    public energyStopStore = inject(EnergyStopStore);

    public ngOnInit(): void {
        this.moveSandbox.moveOnce$.subscribe((move) => {
            this.move = move;
            const { transferee } = MoveUtils.getMovers(move);
            this.energyStopStore.load(DbUtils.getStringId(transferee));
        });
    }

    public onNext(): void {
        void this.navigationSandbox.goToRealEstateDashboard(DbUtils.getStringId(this.move));
    }

    protected readonly EnergyStopSuppliersStatus = EnergyStopSuppliersStatus;
}
